function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M39.979 20.374c0-1.639-.136-2.834-.43-4.075h-19.15v7.397h11.24c-.227 1.838-1.45 4.606-4.17 6.467l-.038.247 6.055 4.584.42.04c3.852-3.476 6.073-8.592 6.073-14.66z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.398 39.863c5.507 0 10.13-1.772 13.507-4.828l-6.436-4.872c-1.722 1.173-4.034 1.993-7.07 1.993a12.253 12.253 0 01-11.604-8.283l-.24.02-6.295 4.761-.082.224c3.354 6.511 10.243 10.985 18.22 10.985z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.795 23.873c-.43-1.24-.68-2.569-.68-3.942 0-1.373.25-2.701.657-3.942l-.011-.264-6.375-4.838-.208.097a19.58 19.58 0 00-2.176 8.947c0 3.211.793 6.245 2.176 8.947l6.617-5.005z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.398 7.707c3.83 0 6.414 1.616 7.887 2.967l5.756-5.492C30.506 1.971 25.905 0 20.398 0 12.421 0 5.532 4.473 2.178 10.984l6.594 5.005c1.655-4.805 6.233-8.282 11.626-8.282z",
  fill: "#EB4335"
})));